<template>
    <b-container fluid class="bv-example-row">
        <b-row >
            <b-col xs="12" sm="12" md="12" lg="5" xl="4">
                <card id="import-log-days">
                    
                    <ImportLogDays></ImportLogDays>
                </card>
            </b-col>
            <b-col xs="12" sm="12" md="12" lg="7" xl="8"> 
                 <card id="import-log-table"> 
                    <ImportLogsTable></ImportLogsTable>
                 </card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import ImportLogDays from '@/components/Timetable/ImportLogDays.vue'
import ImportLogsTable from '@/components/Timetable/ImportLogsTable.vue'
import importLog from '@/store/timetable/ImportLog'


export default {
    data() {
        return {
            title:"Titteli"
        }
    },
    components: {
        ImportLogDays, ImportLogsTable
    },
    created: function() {
        if (!this.$store.state.importLog) {
            this.$store.registerModule("importLog" , importLog);
        }
    },
    methods: {
        onClose (){
            
        }
    }
}
</script>